import { render, staticRenderFns } from "./ArchMap.vue?vue&type=template&id=36e33dd8&scoped=true&"
import script from "./ArchMap.vue?vue&type=script&lang=js&"
export * from "./ArchMap.vue?vue&type=script&lang=js&"
import style0 from "./ArchMap.vue?vue&type=style&index=0&id=36e33dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e33dd8",
  null
  
)

export default component.exports